import { Box, Flex, Paper, Text, Title } from "@mantine/core";
import { IconFileText, IconLock, IconCircleCheck, IconBolt } from "@tabler/icons-react";

export default function SecuritySection() {
  return (
    <Box style={{ background: "linear-gradient(to bottom, #FFFFFF, var(--mantine-color-primary-0))" }} py={60}>
      <Flex direction="column" align="center" px="xl" maw={1200} mx="auto" w="100%">
        <Flex direction="column" align="center" gap="xs" mb="xl">
          <Title order={2} ta="center">
            Security & Collaboration
          </Title>
          <Text c="slate.6" ta="center">
            Enterprise-grade security features protect your confidential business information
          </Text>
        </Flex>

        <Flex direction="column" gap="lg" w="100%">
          <Flex gap="lg" direction={{ base: "column", sm: "row" }}>
            <Paper p="xl" radius="lg" bg="white" withBorder flex={1}>
              <Flex gap="md" align="flex-start">
                <IconFileText size={28} color="var(--mantine-color-violet-6)" style={{ flexShrink: 0, marginTop: 2 }} />
                <Flex direction="column" gap="xs">
                  <Text fw={600}>Auto-Generated NDAs</Text>
                  <Text fz="sm" c="slate.6">
                    Legal framework is automatically established before any sensitive information is shared.
                  </Text>
                </Flex>
              </Flex>
            </Paper>

            <Paper p="xl" radius="lg" bg="white" withBorder flex={1}>
              <Flex gap="md" align="flex-start">
                <IconLock size={28} color="var(--mantine-color-primary-6)" style={{ flexShrink: 0, marginTop: 2 }} />
                <Flex direction="column" gap="xs">
                  <Text fw={600}>Encrypted Data Storage</Text>
                  <Text fz="sm" c="slate.6">
                    All documents and communications are encrypted at rest and in transit using industry-standard
                    protocols.
                  </Text>
                </Flex>
              </Flex>
            </Paper>
          </Flex>

          <Flex gap="lg" direction={{ base: "column", sm: "row" }}>
            <Paper p="xl" radius="lg" bg="white" withBorder flex={1}>
              <Flex gap="md" align="flex-start">
                <IconCircleCheck
                  size={28}
                  color="var(--mantine-color-green-6)"
                  style={{ flexShrink: 0, marginTop: 2 }}
                />
                <Flex direction="column" gap="xs">
                  <Text fw={600}>Activity Audit Logs</Text>
                  <Text fz="sm" c="slate.6">
                    Complete audit trail of all workspace activities for compliance and accountability.
                  </Text>
                </Flex>
              </Flex>
            </Paper>

            <Paper p="xl" radius="lg" bg="white" withBorder flex={1}>
              <Flex gap="md" align="flex-start">
                <IconBolt size={28} color="var(--mantine-color-orange-6)" style={{ flexShrink: 0, marginTop: 2 }} />
                <Flex direction="column" gap="xs">
                  <Text fw={600}>Controlled Access</Text>
                  <Text fz="sm" c="slate.6">
                    Granular permissions ensure each team member only sees what they need to see.
                  </Text>
                </Flex>
              </Flex>
            </Paper>
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
}
